import { NavLink } from "react-router-dom";
import ArrowRightLight from "../assets/icons/arrow-right-light";
import Marker from "../assets/icons/marker";
import "../assets/styles/components/pv-card.scss";

export default function PvCard({ pv_info }) {
  if (pv_info) {
    const sell_type = pv_info.pvAttributes.find(
      (x) => x.name.toUpperCase() === "MODALITA_VENDITA"
    ).value;

    const appaltatori = pv_info.gestoreList.filter((x) => x.isAppaltatore);

    return (
      <NavLink
        to="/check-list"
        state={pv_info}
        className="pv-card d-flex align-items-center p-3 overflow-hidden mb-3 mx-md-auto shadow-sm border"
      >
        <div className="w-100">
          <small className="fw-bold me-2">Punto vendita:</small>
          <span>
            {`${pv_info.pv.codicePv} - ${pv_info.pv.codClasse} - 
          ${sell_type}`}
          </span>

          <div className="d-flex align-items-center  pt-3 py-2 my-2 border-bottom border-top">
            <Marker size={24} color="#eb831d" />
            <span className="ms-2">{`${pv_info.pv.indirizzo} (${pv_info.pv.cap}) ${pv_info.pv.comune} (${pv_info.pv.prov})`}</span>
          </div>

          {pv_info.gestoreList.length > 0 ? (
            <>
              <small className="fw-bold d-block">Gestore/i:</small>
              <ul className="ps-3 my-1">
                {pv_info.gestoreList.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.ragioneSociale} ({item.tipoRelazione})
                    </li>
                  );
                })}
              </ul>
            </>
          ) : null}

          {appaltatori.length > 0 ? (
            <>
              <small className="fw-bold d-block mt-2 pt-2 border-top">
                Appaltatore/i:
              </small>
              <ul className="ps-3 mt-1 mb-0">
                {appaltatori.map((item, index) => {
                  return (
                    <li key={index}>
                      {item.ragioneSociale} ({item.tipoRelazione})
                    </li>
                  );
                })}
              </ul>
            </>
          ) : null}
        </div>
        <ArrowRightLight color="#a0a0a0" size={20} className="ms-3" />
      </NavLink>
    );
  }
}
